import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import {
  ServiceAnniversariesList,
  ServiceAnniversariesListApiProps,
  ServiceAnniversariesListTableSliceState,
} from '../../types/Dashboard/ServiceAnniversaries/serviceAnniversariesListTypes'
import ServiceAnniversariesApi from '../../middleware/api/Dashboard/serviceAnniversariesApi'
import { LoadingState, ValidationError } from '../../types/commonTypes'
import { ApiLoadingState } from '../../middleware/api/apiList'
import { RootState } from '../../stateStore'

const getAllEmployeesAnniversaryList = createAsyncThunk(
  'anniversaryList/getAllEmployeesAnniversaryList',
  async (props: ServiceAnniversariesListApiProps, thunkApi) => {
    try {
      return await ServiceAnniversariesApi.getAllServiceAnniversariesList(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

export const initialAnniversaryListState: ServiceAnniversariesListTableSliceState =
  {
    serviceAnniversariesList: [],
    isLoading: ApiLoadingState.idle,
    listSize: 0,
  }
const anniversaryListSlice = createSlice({
  name: 'anniversaryList',
  initialState: initialAnniversaryListState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllEmployeesAnniversaryList.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(getAllEmployeesAnniversaryList.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.serviceAnniversariesList = action.payload.list
        state.listSize = action.payload.size
      })
  },
})

const isLoading = (state: RootState): LoadingState =>
  state.employeeAnniversaryList.isLoading

const employeesAnniversaryList = (
  state: RootState,
): ServiceAnniversariesList[] =>
  state.employeeAnniversaryList.serviceAnniversariesList

const listSize = (state: RootState): number =>
  state.employeeAnniversaryList.listSize

const upcomingServiceAnniversaries = (
  state: RootState,
): ServiceAnniversariesList[] =>
  state.employeeAnniversaryList.serviceAnniversariesList

const anniversaryListThunk = {
  getAllEmployeesAnniversaryList,
}

const anniversaryListSelectors = {
  isLoading,
  listSize,
  employeesAnniversaryList,
  upcomingServiceAnniversaries,
}

export const anniversaryListService = {
  ...anniversaryListThunk,
  actions: anniversaryListSlice.actions,
  selectors: anniversaryListSelectors,
}

export default anniversaryListSlice.reducer
